import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import t from 'react-translate';
import { AlertMessageType } from 'redux/schemas/app/alert-message';
import { addAlertMessage } from './alert-messages';

// eslint-disable-next-line import/prefer-default-export
export const toggleSftpReport = createAsyncThunk<boolean, { catalogId: string, reportId: number }>(
  'TOGGLE_SFTP_REPORT',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(`${params.catalogId}/course_custom_data_report/${params.reportId}/toggle_sftp_report.json`);
      return response.data.result;
    } catch (error) {
      dispatch(addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.FORM.OOPS(),
        message: t.FORM.ERROR_SOMETHING_WRONG(),
      }));
      return rejectWithValue(error);
    }
  },
);
